{
  "saved": "Enregistré",
  "created": "Créé",
  "updated": "Mis à jour",
  "deleted": "Supprimé",
  "removed": "Retiré",
  "submitted": "Soumis pour approbation",
  "submittedDirect": "Soumis",
  "cancelled": "Annulé",
  "approved": "Approuvé",
  "rejected": "Rejeté",
  "delegated": "Délégué",
  "uploaded": "Téléversé",
  "downloaded": "Téléchargé",
  "exported": "Exporté",
  "imported": "Importé",
  "sent": "Envoyé",
  "copied": "Copié",
  "passwordChanged": "Mot de passe modifié",
  "sessionRefreshed": "Session actualisée",
  "companyUpdated": "Société mise à jour",
  "settingsSaved": "Paramètres enregistrés",
  "failed": "Échec de l'action",
  "failedSave": "Échec de l'enregistrement",
  "failedDelete": "Échec de la suppression",
  "failedLoad": "Échec du chargement des données",
  "failedSubmit": "Échec de la soumission",
  "networkError": "Erreur réseau — vérifiez votre connexion",
  "permissionDenied": "Vous n'avez pas la permission pour cette action",
  "selectCompany": "Sélectionnez d'abord une société dans l'en-tête",
  "requiredFields": "Veuillez remplir tous les champs obligatoires",
  "invalidAmount": "Saisissez un montant valide",
  "passwordsMismatch": "Les mots de passe ne correspondent pas",
  "workingIn": "Vous travaillez dans {{name}}",
  "companySwitchFailed": "Impossible de changer de société. Votre société précédente reste active.",
  "moduleAccessDenied": "Vous n'avez pas accès à ce module",
  "planUpgradeRequired": "Mettez à niveau votre abonnement pour débloquer cette fonctionnalité",
  "hrRosterCopied": "Planning copié en brouillon ({{count}} affectation(s)). Cliquez sur Publier pour l'enregistrer.",
  "hrRosterPublished": "Planning publié pour la semaine",
  "hrPayrollHandoffExported": "CSV de transmission paie téléchargé",
  "hrLaborRulesSaved": "Règles du travail enregistrées"
}
